import React, { Component } from 'react';
import CvSummaryView from './CvSummaryView';
import moment from 'moment';
import { url } from '../../../Server/url/GlobalUrl';

class CvSummaryComponent extends Component {
  state = {
    perssonal_detail: '',
    file_name: '',
    profile_picture: '',
    title_type: '',
    right_to_work_selected: '',
    formated_date: '',
    user_verification_status: [],
    authResponse: '',
    modal_show: false,
    user_verification_description: '',
    user_verification_id: '',
    admin_notice: '',
    user_email: '',
    post_description: '',
    type: '',
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };

  handelData = (e) => {
    if (e.target.checked) {
      var data = e.target.value;
      console.log('data', data);
      this.setState({ type: e.target.value });
      fetch(url + '/api/v1/user/user-verification-status/?type=' + data, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          console.log('response', response);
          if (response['status'] === 201 || response['status'] === 200) {
            console.log('200');
            return response.json();
          } else if (response['status'] === 400) {
            console.log('400');
            return response.json();
          }
        })
        .then((result) => {
          console.log('user-verification-status', result);
          this.setState({ user_verification_id: result[0].id });
          this.setState({
            user_verification_description: result[0].description,
          });
          this.setState({ post_description: result[0].description });
        });
    } else {
      this.setState({ user_verification_description: '' });
      this.setState({ post_description: '' });
    }
  };

  handeltext = (data) => {
    console.log('data', data);
    this.setState({ user_verification_description: data });
  };

  handelsubmit = () => {
    if (this.state.user_verification_id !== '') {
      console.log(
        'inside the handelsubmit',
        this.state.user_email,
        this.state.user_verification_id,
        this.state.user_verification_description
      );
      let form_data = new FormData();
      form_data.append('email', this.state.user_email);
      form_data.append('verification_status', this.state.user_verification_id);
      form_data.append(
        'admin_notice',
        this.state.user_verification_description
      );
      fetch(
        url +
          '/api/v1/user/user-verification-status/' +
          this.state.user_verification_id +
          '/',
        {
          method: 'GET',
        }
      )
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result.type', result.type);

            fetch(
              url +
                '/api/v1/user/submit-details/' +
                localStorage.getItem('cv-id-preview') +
                '/',
              {
                method: 'PUT',
                body: form_data,
              }
            )
              .then((response) => {
                console.log('response', response);
                if (response['status'] === 201 || response['status'] === 200) {
                  console.log('200');
                  fetch(
                    url +
                      '/api/v1/user/applicant-status/?type=' +
                      this.state.type,
                    {
                      method: 'GET',
                    }
                  )
                    .then((res) => res.json())
                    .then(
                      (result) => {
                        if (result.length > 0) {
                          console.log('contract_type', result, result[0].id);
                          let form_data_1 = new FormData();
                          form_data_1.append(
                            'user',
                            localStorage.getItem('cv-id-preview')
                          );
                          form_data_1.append('status', result[0].id);
                          fetch(
                            url +
                              '/api/v1/user/applicant-role-status/' +
                              localStorage.getItem('cv-id-preview') +
                              '/',
                            {
                              method: 'PUT',
                              body: form_data_1,
                            }
                          )
                            .then((response) => {
                              console.log('response', response);
                              if (
                                response['status'] === 201 ||
                                response['status'] === 200
                              ) {
                                return response.json();
                              } else if (response['status'] === 400) {
                                return response.json();
                              }
                            })
                            .then((result) => {
                              console.log('result-admin', result);
                            });
                        }
                      },
                      (error) => {
                        console.log('error', error);
                      }
                    );
                  this.showCustomModal();
                  if (this.state.type == 'Decline Application') {
                    this.setState({
                      authResponse: 'Application declined successfully',
                    });
                  } else if (this.state.type == 'Schedule Interview') {
                    this.setState({
                      authResponse: 'Interview sheduled successfully',
                    });
                  } else {
                    this.setState({
                      authResponse: 'Requested for more info successfully',
                    });
                  }
                  return response.json();
                } else if (response['status'] === 400) {
                  this.showCustomModal();
                  this.setState({
                    authResponse: 'Something Went Wrong Please try again',
                  });
                }
              })
              .then((result) => {
                console.log('result', result);
              })
              .catch((error) => {
                console.log(error);
              });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      alert('please select the option');
    }
  };

  componentDidMount() {
    console.log('cv-id', localStorage.getItem('cv-id'));
    let id = localStorage.getItem('cv-id-preview');
    id = id ? id : localStorage.getItem('cv-id');
    console.log('id____________', id);

    fetch(url + '/api/v1/user/submit-details/' + id + '/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('result', result);
          this.setState({ user_email: result.email });
          this.setState({ perssonal_detail: result });
          //console.log("IMAGE",result.profile_picture.split("/").pop())
          if (result.profile_picture)
            this.setState({
              profile_picture: result.profile_picture.split('/').pop(),
            });

          if (result.filepath) {
            var day = moment(result.date_of_birth).format('MMMM DD, YYYY');
            this.setState({ formated_date: day });
            console.log('day', day);
            const uri = result.filepath.split('/').pop();
            this.setState({ file_name: uri });
          }
          fetch(url + '/api/v1/user/title/' + result.title + '/', {
            method: 'GET',
          })
            .then((res) => res.json())
            .then(
              (result) => {
                this.setState({ title_type: result.type });
                console.log('result', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
          fetch(
            url + '/api/v1/user/right-to-work/' + result.right_to_work + '/',
            {
              method: 'GET',
            }
          )
            .then((res) => res.json())
            .then(
              (result) => {
                this.setState({ right_to_work_selected: result.type });
                console.log('result', result);
              },
              (error) => {
                console.log('error', error);
              }
            );
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/api/v1/user/user-verification-status/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ user_verification_status: result });
          console.log('result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  render() {
    return (
      <CvSummaryView
        handelsubmit={this.handelsubmit}
        handelData={this.handelData}
        handeltext={this.handeltext}
        perssonal_detail={this.state.perssonal_detail}
        file_name={this.state.file_name}
        profile_picture={this.state.profile_picture}
        title_type={this.state.title_type}
        right_to_work_selected={this.state.right_to_work_selected}
        formated_date={this.state.formated_date}
        user_verification_status={this.state.user_verification_status}
        user_verification_description={this.state.user_verification_description}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
      />
    );
  }
}

export default CvSummaryComponent;
